import { Guid } from 'guid-typescript'

import TypingAction from '../../actions/TypingAction'
import ProxySendMessageNodeAction from './ProxySendMessageNodeAction'
export default class ProxyTypingAction implements ProxySendMessageNodeAction {
  action: TypingAction

  guid: string = Guid.create().toString()

  constructor(action: TypingAction) {
    this.action = action
  }

  setTime(time: number): void {
    this.action.time = time
  }

  getModel(): TypingAction {
    return this.action
  }
}
